import { Component } from '@angular/core';
import { ApiService } from './api.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app';
  
  constructor(
    private api:ApiService,
    private spinnerService: Ng4LoadingSpinnerService
  ){

  }
  clientes = [];
  filtro : string = "";
  

  buscar(){
    if (this.filtro != ""){
      this.spinnerService.show();
      this.api.getClientes(this.filtro).then((data: any)=>{
        console.log(data);
        this.spinnerService.hide();
        if (data.length > 0){
          this.clientes = data;
        }else{
          alert("No hay resultados")
        }
      })
    }else{
      alert("Ingrese cédula o nombre del clinete");
    }
    
  }


}
